<div class="d-flex align-items-center flex-column" style="width: 67%; margin: 0 auto;">
  <span class="title">Behaviors - Qualitative</span>
  <div class="relationship">
    <span class="w-100 d-flex justify-content-center">Low</span>
    <span class="w-100 d-flex justify-content-center">Average</span>
    <span class="w-100 d-flex justify-content-center">Excellent</span>
  </div>
</div>
<div style="position: relative;">
  <div class="d-flex align-items-center flex-column right">
    <span class="title">Performance - Quantitative</span>
    <div class="relationship">
      <span class="w-100 d-flex justify-content-center">High</span>
      <span class="w-100 d-flex justify-content-center">Medium</span>
      <span class="w-100 d-flex justify-content-center">Low</span>
    </div>
  </div>
  <div id="chart">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [fill]="chartOptions.fill"
      [dataLabels]="chartOptions.dataLabels"
      [yaxis]="chartOptions.yaxis"
      [theme]="chartOptions.theme"
      [tooltip]="chartOptions.tooltip"
      [plotOptions]="chartOptions.plotOptions"
    ></apx-chart>
  </div>
</div>